// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf, is, maybe, enumOf, recordOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const bsonId = string;
const timestamp = string;

export const isComment = objectOf({
  id: bsonId,
  created_by: bsonId,
  created_at: timestamp,
  edited_at: maybe(timestamp, true),
  message: string,
});

export const isCommentThreadStateChangeLog = objectOf({
  event: enumOf("resolve", "reopen"),
  executed_at: timestamp,
  executed_by: bsonId,
});

export const isSubTarget = anyOf(
  objectOf({
    type: is("test"),
  }),
  objectOf({
    type: is("canvas_step"),
    step_id: bsonId,
  })
);

export const isCommentThread = objectOf({
  id: bsonId,
  sub_target: isSubTarget,
  resolved: maybe(boolean),
  created_at: timestamp,
  created_by: bsonId,
  comments: arrayOf(isComment),
  state_change_logs: maybe(arrayOf(isCommentThreadStateChangeLog)),
});

export const isDeveloperInfo = objectOf({
  id: bsonId,
  email: string,
  first_name: string,
  last_name: string,
  icon_url: maybe(string, true),
});

export const isDeveloperInfoMap = recordOf(isDeveloperInfo);

export const isCreateCommentThreadResult = objectOf({
  thread: isCommentThread,
  developers: isDeveloperInfoMap,
});

export const isGetCommentThreadsResult = objectOf({
  threads: arrayOf(isCommentThread),
  developers: isDeveloperInfoMap,
});

export const isCreateCommentResult = objectOf({
  comment: isComment,
  developers: isDeveloperInfoMap,
});

export const isEmptyResponse = objectOf({});
